export default function Footer() {
  return (
    <>
      <div className="bg-white shadow p-3 text-center">
        <b>Copyright@Junkin 2024</b>
      </div>
    </>
  );
}
